import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'material-ui';

import styles from './styles.scss';

export default class ResponseListFilters extends React.Component {
  static propTypes = {
    numTotal: PropTypes.number,
    numFiltered: PropTypes.number,
    updateFilter: PropTypes.func.isRequired,
    filter: PropTypes.string,
  }

  static defaultProps = {
    numTotal: 0,
    numFiltered: 0,
    filter: '',
  }

  render() {
    const { numTotal, numFiltered, updateFilter, filter } = this.props;

    return (<div className={styles.listFilter}>
      <div className={styles.filters}>
        <TextField floatingLabelText='Filter responses' onChange={updateFilter} value={filter} />
      </div>
      <div className={styles.infoLine}>
        {numFiltered} (of {numTotal}) responses displayed
      </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Forms/ResponseListFilters.js